/*说明
  1. main.js里这样调用
    import common from './lib/common'
    Vue.use(common);

  2. 组件里直接这样调用this.test();
*/
import { Message } from 'element-ui';
export default{
  install(Vue,options){
    //可以自定义变量
    Vue.prototype.vStatus = new Vue();//用于非父子组件通信
    //重置表单里带有验证的
    Vue.prototype.resetFieldsForm = function (formName) {
      this.$refs[formName].resetFields();
    };
    //清空查询表单
    Vue.prototype.resetQueryForm = function (formName) {
      this.$refs[formName].$el.reset();
    };
    Vue.prototype.getVcodeGuid = function () {
      function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      }
      function guid() {
        return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
      }
      return  guid();
    };

    //排序
    Vue.prototype.sortHandle = function (obj) {
      if(obj.prop){
        return obj.prop+' '+obj.order.replace('ending','')
      }else {
        console.log('prop is not defined，将采用默认排序');
        return ''
      }
    };


    //table的数据add行
    //data:当前数据，row:需要添加的行数据，pageSize:每页的行数
    Vue.prototype.updataRow = function(data,row,pageSize){
      data.unshift(row);
      data.length === pageSize+1 ? data.pop() : data;
      return data;
    };
    //计算table页数和总条数
    Vue.prototype.updataTableTot = function (obj) {
      obj.total = obj.total - 1;
      obj.len === 0 ? obj.totalPage = obj.total/obj.pageSize : obj.totalPage = Math.ceil(obj.total/obj.pageSize);
      return {
        total:obj.total,
        totalPage:obj.totalPage
      };
    };
    Vue.prototype.format = function (_,date) {
      let o = {
        "M+" : date.getMonth()+1,                 //月份
        "d+" : date.getDate(),                    //日
        "h+" : date.getHours(),                   //小时
        "m+" : date.getMinutes(),                 //分
        "s+" : date.getSeconds(),                 //秒
        "q+" : Math.floor((date.getMonth()+3)/3), //季度
        "S"  : date.getMilliseconds()             //毫秒
      };
      if(/(y+)/.test(_))
        _ = _.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
      for(let k in o)
        if(new RegExp("("+ k +")").test(_))
          _ = _.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      return _;
    };


    Vue.prototype.dayType = function (Time) {
      if(!Time){
        return
      }
      var hour = new Date('2018-01-01 ' + Time).getHours();
      if (hour < 12){
        return "上午"
      }else if (hour < 18){
        return "下午"
      } else if (hour < 24){
        return "晚上"
      }
    };

    Vue.prototype.dateCompate = function (TimeA,TimeB) {
      if(!TimeA && !TimeB){
        return
      }
      let _TimeA = new Date('2018-01-01 ' + TimeA);
      let _TimeB = new Date('2018-01-01 ' + TimeB);
      return Date.parse(_TimeA) < Date.parse(_TimeB);
    };

    // form正则验证【返回false时提示状态,否则返回true】
    /*
    regArr:数组 [{vName:'',value:'',toastText:''}]
      vName       需要验证的正则名称【必填】
      value         需要验证的值
      toastText   需要提示的值【常用于表单状态: ____不能为空, 请输入正确____】
    */
    Vue.prototype.formVal = function (regArr) {
      //---------------加正则start【仅仅需在这里添加就好了，封线外不要改】-------------
      let _validateObj = {
        isMobile: /^[1][3,4,5,7,8,9][0-9]{9}$/,    //手机号
        isCardId: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/    // 身份证号【15or18】
      };
      //---------------添加正则end-----------------------------------------------------
      if(regArr){
        let isPass = true;
        function validateItem (obj) {
          if (_validateObj[obj.vName]) {
            let toValidate = (myreg) => {
              if (!myreg.test(obj.value)) {
                if (obj.value === '') {
                  if(obj.isRequired){
                    if (obj.toastText) {
                      Message.error(obj.toastText + '不能为空');
                      return false;
                    }
                    return false;
                  }else {
                    return true;
                  }
                } else {
                  if (obj.toastText) {
                    Message.error('请输入正确的' + obj.toastText);
                  }
                  return false;
                }
              } else {
                return true;
              }
            };
            return toValidate(_validateObj[obj.vName])
          }
          if (obj.vName === '' || obj.vName === null || obj.vName === undefined) {
            console.log('请输入正确的formVal参数【vName】')
          }
        }
        for (let i=0;i<regArr.length;i++) {
          if (!validateItem(regArr[i])){
            isPass = false;
            break;  //跳出循环
          }
        }
        return isPass;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/HzCommon.js